window.SignUpSocialLinksForm = function ($scope, hUser, brand, jobId, localize, httpHelper, referrer) {

    let form = this;
    let formName = "signup-social-links-form";
    let _protected = BaseForm.call(form, formName, $scope);
    form.isKickstart = referrer === 'Kickstart';
    form.showOptInMessagesCb = false;
    if (form.isKickstart) {
        form.data.is_public = true;
    }
    form.isOAuthEnabled = publicConfiguration.isOAuthEnabled();

    form.socialLoginStarted = () => {
        form.socialLogin = true;

        $scope.$on('logged-in-from-oauth', (event, provider, userData) => {
            delete form.socialLogin;
        });

        $scope.$on('error-from-oauth', (event, provider, error) => {
            delete form.socialLogin;
        });
    };
};
